export default "__VITE_ASSET__CSomK5Bo__"